<template>
  <footer id="footer" class="m-0 text-white">
    <div class="container pb-5">
      <div class="row">
        <!-- Address Section -->
        <div class="col-lg-4 text-center">
          <img src="@/assets/icons/footer/pin.svg" alt="Location Icon" class="mb-2" />
          <p class="mb-0 colmn">
            {{ $t("base.footer.columns.first.name") }}<br />
            La Strada da Pizzögna 3<br />
            CH - 6574 Vira Gambarogno<br />
          </p>
        </div>

        <!-- Contact Section -->
        <div class="col-lg-4 text-center">
          <img src="@/assets/icons/footer/contact.svg" alt="Contact Icon" class="mb-2 icon" style="width: 24px; height: 24px;"/>
          <p class="mb-0 colmn">
            <a href="mailto:info@casafile.ch" class="text-decoration-none text-white">info@casafile.ch</a><br />
            <a href="tel:+41917953590" class="text-decoration-none text-white">+41 91 795 35 90</a>
          </p>
        </div>

        <!-- Social Section -->
        <div class="col-lg-4 text-center">
          <p class="mb-3">{{ $t("base.footer.columns.third.title") }}</p>
          <div class="d-flex justify-content-center mb-2 colmn">
            <a href="https://facebook.com/casafile" target="_blank" class="me-3">
              <img src="@/assets/icons/footer/Facebook.svg" alt="Facebook Icon" class="icon" />
            </a>
            <a href="https://linkedin.com/company/casafile" target="_blank" class="me-3">
              <img src="@/assets/icons/footer/Linkedin.svg" alt="LinkedIn Icon" class="icon" />
            </a>
            <a href="https://x.com/casafile" target="_blank" class="me-3">
              <img src="@/assets/icons/footer/X.svg" alt="Twitter Icon" class="icon" />
            </a>
          </div>
          <div class="d-flex justify-content-center mb-2 colmn">
            <a href="https://instagram.com/casafile" target="_blank" class="me-3">
              <img src="@/assets/icons/footer/Instagram.svg" alt="Instagram Icon" class="icon" />
            </a>
            <a href="https://www.youtube.com/channel/UCVLPbMT8CWJRI1Kre6il_yg" target="_blank" class="me-3">
              <img src="@/assets/icons/footer/Youtube.svg" alt="YouTube Icon" class="icon" />
            </a>
            <a href="https://www.xing.com/pages/casafilegmbh" target="_blank">
              <img src="@/assets/icons/footer/Xing.svg" alt="Xing Icon" class="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom Section -->
    <div id="footer-bottom" class="text-white">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center mb-0">
              <p class="mb-0" style="font-size: 18px;">{{ $t("base.footer.copyright.title") }}</p>
            <p class="mb-0" style="margin-top: 8px; font-size: 14px;">{{ $t('base.footer.copyright.subtitle', { year: currentYear }) }}</p>
            <!-- Expandable GDPR Section -->
            <div class="row g-0">
              <div class="col-12 text-center mb-0">
                <button class="button" @click="onExpand">
                  <div class="d-flex align-items-center justify-content-center">
                    <span class="me-2" style="font-size: 12px; font-weight: 400;">{{ $t("base.footer.copyright.button") }}</span>
                    <i class="fas fa-arrow-down" :class="{ 'rotate-arrow': expandPrivacy }"></i>
                  </div>
                </button>
              </div>
            </div>
            <transition name="fade">
              <div v-if="expandPrivacy" class="text-center">
                <p style="font-size: 14px;" class="" v-html="$t('base.footer.copyright.content')"></p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  data() {
    return {
      expandPrivacy: false,
    };
  },
  methods: {
    onExpand() {
      this.expandPrivacy = !this.expandPrivacy;
    }
  },
};
</script>

<style lang="scss" scoped>
#footer {
  background-color: $primary-dark;
  font-size: 14px;
  font-family: "Noto Serif SC", serif;

  p {
    color: $white;
    font-size: 16px;
  }
}

#footer-bottom {
  background-color: $primary-color;
  padding: 30px 0 20px 0;
}

.rotate-arrow {
  transition: transform 0.3s;
  transform: rotate(180deg); /* Rotates arrow 180 degrees for up and down toggle */
}

.button {
  background-color: transparent;
  color: $white;
  border: 0;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  outline: none;
  i {
      color: $white;
      -webkit-text-stroke: 1.5px $primary-color;
  }
  div {
      gap: 4px;
  }
}

.colmn {
  margin-top: .75rem;
}

.icon {
  width: 30px;
  height: 30px;
  filter: invert(1);
}
</style>
